/* ==========================================================================
   NOCTSX — Nocturne theme.js
   Vanilla, no dependencies. Everything is progressive: pages work without JS,
   JS layers on instant search, wishlist, ajax cart, variant picking, filters.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = Object.assign({
    moneyFormat: '{{amount}}0 IQD',
    routes: { root: '/', cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartGet: '/cart.js', search: '/search', suggest: '/search/suggest.json', wishlist: '/pages/wishlist', predictive: true },
    afterAdd: 'drawer',
    popular: [],
    collections: [],
    whatsapp: '',
    strings: {}
  }, window.NS_CONFIG || {});
  cfg.popular = (cfg.popular || []).map(function (s) { return String(s).trim(); }).filter(Boolean);

  var S = Object.assign({
    added: 'أُضيف للسلة',
    viewCart: 'عرض السلة',
    wishAdd: 'أُضيف للمفضلة',
    wishRemove: 'أُزيل من المفضلة',
    soldOut: 'نفد',
    unavailable: 'غير متوفر',
    addToCart: 'أضف للسلة',
    chooseOptions: 'اختر الخيارات',
    inStock: 'متوفر',
    lowStock: 'باقي {n} فقط',
    products: 'منتجات',
    collections: 'الأقسام',
    suggestions: 'اقتراحات',
    popular: 'بحث شائع',
    viewAll: 'عرض كل النتائج',
    noResults: 'ما لقينا شي يطابق',
    tryAgain: 'جرّب كلمة ثانية أو تصفح الأقسام',
    error: 'صار خطأ، حاول مرة ثانية',
    emptyWish: 'مفضلتك فارغة',
    emptyWishText: 'اضغط على القلب في أي منتج حتى يظهر هنا.',
    onlyLeft: 'باقي {n}',
    new: 'جديد'
  }, cfg.strings || {});

  /* ------------------------------------------------------------------ utils */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { el && el.addEventListener(ev, fn, o); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var debounce = function (fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var f = cfg.moneyFormat || '{{amount}}';
    var n = (Number(cents) || 0) / 100;
    var grp = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var parts = n.toFixed(2).split('.');
    var ip = parts[0], dp = parts[1], nd = n.toFixed(0);
    var map = {
      amount: grp(ip, ',') + '.' + dp,
      amount_no_decimals: grp(nd, ','),
      amount_with_comma_separator: grp(ip, '.') + ',' + dp,
      amount_no_decimals_with_comma_separator: grp(nd, '.'),
      amount_with_apostrophe_separator: grp(ip, "'") + '.' + dp,
      amount_no_decimals_with_space_separator: grp(nd, ' '),
      amount_with_space_separator: grp(ip, ' ') + ',' + dp,
      amount_with_period_and_space_separator: grp(ip, ' ') + '.' + dp
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return map[k] !== undefined ? map[k] : map.amount; }).replace(/<[^>]+>/g, '');
  }

  function img(url, w) {
    if (!url) return '';
    if (typeof url === 'object') url = url.url || url.src || '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (!w) return url;
    if (/[?&]width=/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function getJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }, opts || {})).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'error'); e.data = j; throw e; } return j; });
    });
  }

  var lockCount = 0;
  function lock(onOff) {
    lockCount = Math.max(0, lockCount + (onOff ? 1 : -1));
    document.body.classList.toggle('is-locked', lockCount > 0);
  }

  /* scrim shared by sheet / drawers */
  var scrim = $('#ns-scrim');
  var scrimHandlers = [];
  function scrimOn(handler) { scrimHandlers.push(handler); scrim && scrim.classList.add('is-on'); }
  function scrimOff(handler) { scrimHandlers = scrimHandlers.filter(function (h) { return h !== handler; }); if (!scrimHandlers.length) scrim && scrim.classList.remove('is-on'); }
  on(scrim, 'click', function () { scrimHandlers.slice().forEach(function (h) { h(); }); });

  /* toast */
  var toastEl, toastT;
  function toast(o) {
    if (!toastEl) {
      toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status');
      toastEl.innerHTML = '<div class="toast__in"></div>'; document.body.appendChild(toastEl);
    }
    var inner = $('.toast__in', toastEl);
    inner.innerHTML = (o.img ? '<img src="' + esc(img(o.img, 120)) + '" alt="">' : '<svg class="ic"><use href="#i-' + (o.icon || 'check') + '"></use></svg>') +
      '<span>' + esc(o.text) + '</span>' + (o.link ? '<a href="' + esc(o.link) + '">' + esc(o.linkText || '') + '</a>' : '');
    clearTimeout(toastT);
    toastEl.classList.add('is-on');
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, o.ms || 2600);
  }

  /* ------------------------------------------------------------------ theme */
  function setTheme(t, animate) {
    document.documentElement.setAttribute('data-theme', t);
    try { localStorage.setItem('ns-theme', t); } catch (e) { }
    var m = $('meta[name="theme-color"]'); if (m) m.setAttribute('content', t === 'dark' ? '#09090d' : '#f4f3ef');
    if (animate) $$('[data-theme-toggle]').forEach(function (b) { b.classList.remove('is-spin'); void b.offsetWidth; b.classList.add('is-spin'); });
  }
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-theme-toggle]'); if (!b) return;
    var next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    /* browser-native crossfade between the two themes where supported */
    if (document.startViewTransition && !reduced) document.startViewTransition(function () { setTheme(next, true); });
    else setTheme(next, true);
  });

  /* ------------------------------------------------------------------ header */
  var hdr = $('.hdr');
  if (hdr) {
    var lastY = 0, ticking = false;
    var onScroll = function () {
      var y = window.scrollY || 0;
      hdr.classList.toggle('is-scrolled', y > 8);
      lastY = y; ticking = false;
    };
    on(window, 'scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------------ wishlist */
  var Wish = {
    key: 'ns-wish',
    get: function () { try { return JSON.parse(localStorage.getItem(this.key) || '[]'); } catch (e) { return []; } },
    set: function (a) { try { localStorage.setItem(this.key, JSON.stringify(a.slice(0, 120))); } catch (e) { } this.paint(); },
    has: function (h) { return this.get().indexOf(h) > -1; },
    toggle: function (h) { var a = this.get(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.unshift(h); this.set(a); return i === -1; },
    paint: function () {
      var a = this.get(), n = a.length;
      $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', a.indexOf(b.getAttribute('data-wish')) > -1 ? 'true' : 'false'); });
      $$('[data-wish-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
      $$('[data-wish-dock]').forEach(function (b) { b.classList.toggle('is-full', n > 0); });
    }
  };
  on(document, 'click', function (e) {
    var b = e.target.closest('button[data-wish]'); if (!b) return;
    e.preventDefault();
    var added = Wish.toggle(b.getAttribute('data-wish'));
    var c = $$('[data-wish-count]')[0]; if (c) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
    toast({ text: added ? S.wishAdd : S.wishRemove, icon: 'heart', link: added ? cfg.routes.wishlist : '', linkText: 'المفضلة' });
    if (!added && b.closest('[data-wishlist-page]')) { var card = b.closest('.card'); if (card) { card.style.transition = 'opacity .25s'; card.style.opacity = '0'; setTimeout(function () { card.remove(); wishlistEmptyCheck(); }, 250); } }
  });

  /* ------------------------------------------------------------------ product card (JS twin of snippets/ns-card.liquid) */
  function normalize(p) {
    if (!p) return null;
    var fromPredictive = typeof p.price === 'string';
    var price = fromPredictive ? Math.round(parseFloat(p.price) * 100) : (p.price != null ? p.price : (p.price_min || 0));
    var cmpRaw = fromPredictive ? (p.compare_at_price_max || p.compare_at_price) : (p.compare_at_price != null ? p.compare_at_price : p.compare_at_price_max);
    var compare = cmpRaw ? (typeof cmpRaw === 'string' ? Math.round(parseFloat(cmpRaw) * 100) : cmpRaw) : null;
    var image = p.featured_image ? (p.featured_image.url || p.featured_image.src || p.featured_image) : (p.images && p.images[0] ? (p.images[0].src || p.images[0]) : '');
    var image2 = p.images && p.images[1] ? (p.images[1].src || p.images[1]) : '';
    var variants = p.variants || [];
    var single = variants.length === 1 ? variants[0] : null;
    var handle = p.handle || (p.url ? p.url.split('?')[0].split('/').pop() : '');
    return {
      handle: handle, title: p.title || '', url: (p.url || ('/products/' + handle)).split('?')[0],
      image: image, image2: image2, price: price, compare: compare, available: p.available !== false,
      variantId: single ? single.id : null, multi: variants.length > 1, qty: single && single.inventory_quantity != null ? single.inventory_quantity : null
    };
  }

  function cardHTML(p, opts) {
    opts = opts || {};
    var sale = p.compare && p.compare > p.price;
    var pct = sale ? Math.round((1 - p.price / p.compare) * 100) : 0;
    var out = !p.available;
    var stock = out ? '<div class="card__stock card__stock--out">' + S.soldOut + '</div>' :
      (p.qty != null && p.qty > 0 && p.qty <= 3 ? '<div class="card__stock card__stock--low">' + S.lowStock.replace('{n}', p.qty) + '</div>' : '<div class="card__stock">' + S.inStock + '</div>');
    var add = out ? '' : (p.variantId && !p.multi ?
      '<form class="card__add" action="' + cfg.routes.cartAdd.replace('.js', '') + '" method="post" data-ajax-add><input type="hidden" name="id" value="' + p.variantId + '"><input type="hidden" name="quantity" value="1">' +
      (p.p3d && cfg.p3d && cfg.p3d.name ? '<input type="hidden" name="properties[' + esc(cfg.p3d.name) + ']" value="' + esc(cfg.p3d.value) + '">' : '') + '<button class="add" type="submit" aria-label="' + S.addToCart + '"><svg class="ic"><use href="#i-plus"></use></svg><svg class="ic"><use href="#i-check"></use></svg></button></form>' :
      '<a class="add" href="' + esc(p.url) + '" aria-label="' + S.chooseOptions + '"><svg class="ic"><use href="#i-arrow"></use></svg></a>');
    return '<article class="card' + (out ? ' is-sold' : '') + (opts.cls ? ' ' + opts.cls : '') + '" data-handle="' + esc(p.handle) + '">' +
      '<div class="card__media"><a class="card__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
      '<img src="' + esc(img(p.image, 480)) + '" srcset="' + esc(img(p.image, 360)) + ' 360w, ' + esc(img(p.image, 600)) + ' 600w" sizes="(min-width:1000px) 280px, 50vw" alt="" loading="lazy" decoding="async" width="600" height="600">' +
      (p.image2 ? '<img class="card__img2" src="' + esc(img(p.image2, 480)) + '" alt="" loading="lazy" decoding="async" width="600" height="600">' : '') + '</a>' +
      '<div class="card__badges">' + (sale ? '<span class="badge badge--sale ltr">-' + pct + '%</span>' : '') + (out ? '<span class="badge badge--out">' + S.soldOut + '</span>' : '') + '</div>' +
      '<button class="heart" type="button" data-wish="' + esc(p.handle) + '" aria-label="المفضلة" aria-pressed="' + (Wish.has(p.handle) ? 'true' : 'false') + '"><svg class="ic"><use href="#i-heart"></use></svg></button></div>' +
      '<div class="card__body"><h3 class="card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
      '<div class="card__foot"><div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__now ltr">' + money(p.price) + '</span>' + (sale ? '<s class="price__was ltr">' + money(p.compare) + '</s>' : '') + '</div>' + add + '</div>' + stock + '</div></article>';
  }

  /* product data for the JS cards (wishlist, recently viewed). templates/product.ns-card.liquid returns the same JSON as
     /products/<handle>.js plus whether it's a 3D print, so quick add carries the checkout label; .js is the fallback.
     No "Accept: application/json" here: Shopify would answer with its own product JSON and skip the view. */
  var xhr = { headers: { 'X-Requested-With': 'XMLHttpRequest' } };
  function cardData(h) {
    return getJSON('/products/' + h + '?view=ns-card', xhr).then(function (j) {
      var p = j && typeof j.p3d === 'boolean' ? normalize(j.product) : null; if (!p) throw new Error('view'); p.p3d = j.p3d; return p;
    }).catch(function () { return getJSON('/products/' + h + '.js').then(normalize); });
  }

  /* ------------------------------------------------------------------ cart */
  var Cart = {
    drawer: $('[data-cart-drawer]'),
    busy: false,
    stamping: false,
    open: function (refresh) {
      var d = this.drawer; if (!d) { location.href = cfg.routes.cart; return; }
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lock(true); scrimOn(Cart.closeBound);
      if (refresh !== false) this.refresh();
      setTimeout(function () { var f = $('.drawer__h button', d); f && f.focus(); }, 50);
    },
    close: function () { var d = Cart.drawer; if (!d || !d.classList.contains('is-open')) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lock(false); scrimOff(Cart.closeBound); },
    refresh: function () {
      var d = this.drawer; if (!d) return Promise.resolve();
      return fetch(cfg.routes.root + '?sections=ns-cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); }).then(function (j) { Cart.swap(j); }).catch(function () { });
    },
    swap: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-section-swap]', doc);
        var cur = $('[data-section-id="' + id + '"] [data-section-swap], #shopify-section-' + id + ' [data-section-swap]');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML; init(cur);
          if (Cart.stamping) $$('[name="checkout"]', cur).forEach(function (b) { b.classList.add('btn--loading'); });
        }
        var count = $('[data-cart-total-count]', doc);
        if (count) Cart.paintCount(parseInt(count.getAttribute('data-cart-total-count'), 10) || 0);
      });
    },
    paintCount: function (n) {
      $$('[data-cart-count]').forEach(function (c) { var was = c.textContent; c.textContent = n; c.hidden = n === 0; if (was !== String(n)) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); } });
      $$('[data-cart-fab]').forEach(function (f) { f.hidden = n === 0; });
    },
    sectionIds: function () {
      var ids = ['ns-cart-drawer'];
      var page = $('[data-cart-page]'); if (page) ids.push(page.getAttribute('data-section-id'));
      return ids.join(',');
    },
    add: function (body, btn, meta) {
      if (Cart.busy) return; Cart.busy = true;
      btn && btn.classList.add(btn.classList.contains('add') ? 'is-busy' : 'btn--loading');
      body.sections = Cart.sectionIds(); body.sections_url = location.pathname;
      return getJSON(cfg.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) {
          Cart.swap(res.sections);
          if (btn && btn.classList.contains('add')) { btn.classList.add('is-ok'); setTimeout(function () { btn.classList.remove('is-ok'); }, 1600); }
          if (cfg.afterAdd === 'drawer' && Cart.drawer) Cart.open(false);
          else toast({ text: S.added, img: (res.items ? res.items[0] : res).image || (meta && meta.image), link: cfg.routes.cart, linkText: S.viewCart });
        })
        .catch(function (e) { toast({ text: e.message || S.error, icon: 'alert', ms: 3500 }); })
        .then(function () { Cart.busy = false; btn && btn.classList.remove('btn--loading', 'is-busy'); });
    },
    change: function (key, qty, lineEl) {
      lineEl && lineEl.classList.add('is-busy');
      return getJSON(cfg.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty, sections: Cart.sectionIds(), sections_url: location.pathname }) })
        .then(function (res) { Cart.swap(res.sections); })
        .catch(function (e) { toast({ text: e.message || S.error, icon: 'alert' }); lineEl && lineEl.classList.remove('is-busy'); });
    }
  };
  Cart.closeBound = function () { Cart.close(); };
  on(document, 'click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); Cart.open(); return; }
    if (t.closest('[data-cart-close]')) { Cart.close(); return; }
    var q = t.closest('[data-qty]');
    if (q) {
      var line = q.closest('[data-line-key]'); var input = $('input', q.parentNode);
      var n = Math.max(0, (parseInt(input.value, 10) || 0) + (q.getAttribute('data-qty') === '+' ? 1 : -1));
      input.value = n;
      if (line) Cart.change(line.getAttribute('data-line-key'), n, line);
      return;
    }
    var rm = t.closest('[data-remove]');
    if (rm) { e.preventDefault(); var l = rm.closest('[data-line-key]'); Cart.change(l.getAttribute('data-line-key'), 0, l); }
  });
  on(document, 'change', function (e) {
    var input = e.target.closest('[data-line-key] .stepper input'); if (!input) return;
    var line = input.closest('[data-line-key]'); Cart.change(line.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0), line);
  });
  /* one /cart/add.js item from a quick-add form, line item properties included */
  function formItem(f) {
    var fd = new FormData(f), item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 };
    var props = {}; fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;
    return item;
  }
  on(document, 'submit', function (e) {
    var f = e.target.closest('form[data-ajax-add]'); if (!f) return;
    e.preventDefault();
    Cart.add({ items: [formItem(f)] }, $('button[type="submit"]', f), { image: f.getAttribute('data-image') });
  });
  /* 3D-printed lines that reached the cart without the checkout label (carts from before the label existed):
     stamp the line item property just before checkout so Shopify shows it there too. Never blocks checkout.
     Cart.stamping swallows double taps while it runs (it survives cart re-renders, unlike the form);
     form.__p3d marks a form already handed over to the native submit. */
  on(document, 'submit', function (e) {
    var f = e.target, sub = e.submitter, p3d = cfg.p3d, co = $('[name="checkout"]', f);
    if (co && Cart.stamping) { e.preventDefault(); return; }
    if (e.defaultPrevented || f.__p3d || !p3d || !p3d.name || !co || (sub && sub.name !== 'checkout')) return;
    var root = f.closest('[data-section-swap]'), lines = $$('[data-p3d-fix]', root || document);
    if (!lines.length) return;
    e.preventDefault(); Cart.stamping = true;
    (sub || co).classList.add('btn--loading');
    var go = function () {
      if (go.done) return; go.done = true; Cart.stamping = false;
      /* a cart re-render (quantity change, drawer refresh) may have replaced the form meanwhile: submit the live one */
      var form = f.isConnected ? f : root && ($('[name="checkout"]', root) || {}).form;
      if (!form) return;
      form.__p3d = true;
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; form.appendChild(i);
      HTMLFormElement.prototype.submit.call(form);
    };
    setTimeout(go, 6000);
    lines.reduce(function (chain, l) {
      return chain.then(function () {
        var qty = $('.stepper input', l); if (!qty) return;
        var props = {}; try { props = JSON.parse(l.getAttribute('data-p3d-fix')) || {}; } catch (x) { }
        props[p3d.name] = p3d.value;
        return getJSON(cfg.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: l.getAttribute('data-line-key'), quantity: Math.max(0, parseInt(qty.value, 10) || 0), properties: props }) }).catch(function () { });
      });
    }, Promise.resolve()).then(go);
  });
  /* back from checkout: the page may come back from bfcache / disk cache with the line keys the stamping above changed */
  on(window, 'pageshow', function (e) {
    var nav = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!e.persisted && !(nav && nav.type === 'back_forward')) return;
    $$('[name="checkout"].btn--loading').forEach(function (b) { b.classList.remove('btn--loading'); });
    Cart.stamping = false; $$('form').forEach(function (x) { x.__p3d = false; });
    if ($('[data-p3d-fix]')) getJSON(location.pathname + '?sections=' + Cart.sectionIds(), xhr).then(Cart.swap).catch(function () { });
  });
  on(document, 'keydown', function (e) { if (e.key === 'Escape') { Cart.close(); Search.close(); Filters.close(); Menu.close(); } });

  /* ------------------------------------------------------------------ mobile menu (glass panel under the header) */
  var Menu = {
    open: function () {
      var m = $('[data-menu]'), b = $('[data-menu-toggle]'); if (!m || m.classList.contains('is-open')) return;
      m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); b && (b.classList.add('is-open'), b.setAttribute('aria-expanded', 'true')); lock(true); scrimOn(Menu.closeBound);
    },
    close: function () {
      var m = $('[data-menu].is-open'), b = $('[data-menu-toggle]'); if (!m) return;
      m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); b && (b.classList.remove('is-open'), b.setAttribute('aria-expanded', 'false')); lock(false); scrimOff(Menu.closeBound);
    }
  };
  Menu.closeBound = function () { Menu.close(); };
  on(document, 'click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) { $('[data-menu].is-open') ? Menu.close() : Menu.open(); return; }
    if (e.target.closest('[data-menu] a')) Menu.close();
  });
  if (Cart.drawer) getJSON(cfg.routes.cartGet).then(function (c) { Cart.paintCount(c.item_count); }).catch(function () { });

  /* ------------------------------------------------------------------ search (dock) */
  var Search = {
    input: $('[data-dock-search] input'), form: $('[data-dock-search]'), sheet: $('[data-sheet]'), clear: $('[data-dock-clear]'),
    open: false, cache: {}, ctrl: null, active: -1,
    init: function () {
      var s = this; if (!s.input || !s.sheet) return;
      s.scroll = $('.sheet__scroll', s.sheet);
      on(s.input, 'focus', function () { s.show(); });
      on(s.input, 'click', function () { s.show(); });
      on(s.input, 'input', function () { s.clear.hidden = !s.input.value; s.query(s.input.value); });
      on(s.clear, 'click', function () { s.input.value = ''; s.clear.hidden = true; s.input.focus(); s.query(''); });
      on(s.form, 'submit', function (e) { if (!s.input.value.trim()) { e.preventDefault(); s.input.focus(); } else s.remember(s.input.value); });
      on(s.sheet, 'click', function (e) {
        if (e.target.closest('.sr')) s.remember(s.input.value);
        var clr = e.target.closest('[data-recent-clear]'); if (clr) { e.preventDefault(); try { localStorage.removeItem('ns-recent-q'); } catch (x) { } s.render(s.initialHTML()); }
      });
      /* rotating placeholder hints while the field is idle */
      if (cfg.popular.length > 1 && !reduced) {
        var base = s.input.getAttribute('placeholder') || '', k = 0;
        setInterval(function () { if (document.activeElement === s.input || s.input.value) return; k = (k + 1) % (cfg.popular.length + 1); s.input.setAttribute('placeholder', k === 0 ? base : 'ابحث عن ' + cfg.popular[k - 1] + '…'); }, 2800);
      }
      on(s.input, 'keydown', function (e) {
        var rows = $$('.sr', s.sheet); if (!rows.length) return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault(); s.active = (s.active + (e.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length;
          rows.forEach(function (r, i) { r.classList.toggle('is-active', i === s.active); }); rows[s.active].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter' && s.active > -1) { e.preventDefault(); location.href = rows[s.active].getAttribute('href'); }
      });
      s.query('');
    },
    show: function () {
      if (this.open) return; this.open = true;
      this.sheet.classList.add('is-open'); this.sheet.setAttribute('aria-hidden', 'false');
      scrimOn(Search.closeBound); $$('[data-dock-home]').forEach(function (b) { b.classList.remove('is-on'); });
    },
    close: function () {
      if (!this.open) return; this.open = false; this.active = -1;
      this.sheet.classList.remove('is-open'); this.sheet.setAttribute('aria-hidden', 'true');
      scrimOff(Search.closeBound); this.input && this.input.blur();
    },
    query: debounce(function (q) { Search.run(q); }, 180),
    run: function (q) {
      var s = this; q = (q || '').trim(); s.active = -1;
      if (q.length < 2) { s.render(s.initialHTML()); return; }
      if (s.cache[q]) { s.render(s.cache[q]); return; }
      if (s.ctrl) s.ctrl.abort(); s.ctrl = window.AbortController ? new AbortController() : null;
      s.render('<div class="skel"></div><div class="skel"></div><div class="skel"></div>');
      var url = cfg.routes.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      var req = cfg.routes.predictive ? getJSON(url, { signal: s.ctrl && s.ctrl.signal }).then(function (j) { return j.resources.results; }) : Promise.reject(new Error('off'));
      req.catch(function (e) {
        if (e.name === 'AbortError') throw e;
        return getJSON(cfg.routes.search + '?view=ns&type=product&q=' + encodeURIComponent(q), { signal: s.ctrl && s.ctrl.signal }).then(function (j) { return { products: j.products || [], collections: [], queries: [] }; });
      }).then(function (r) {
        var html = s.resultsHTML(q, r); s.cache[q] = html; if (s.input.value.trim() === q) s.render(html);
      }).catch(function (e) { if (e.name !== 'AbortError') s.render('<div class="sheet__empty"><svg class="ic"><use href="#i-alert"></use></svg><b>' + S.error + '</b></div>'); });
    },
    render: function (html) { if (this.scroll) this.scroll.innerHTML = html; },
    recent: function () { try { return JSON.parse(localStorage.getItem('ns-recent-q') || '[]'); } catch (e) { return []; } },
    remember: function (q) {
      q = (q || '').trim(); if (q.length < 2) return;
      var a = this.recent().filter(function (x) { return x !== q; }); a.unshift(q);
      try { localStorage.setItem('ns-recent-q', JSON.stringify(a.slice(0, 6))); } catch (e) { }
    },
    initialHTML: function () {
      var h = '', rec = this.recent();
      if (rec.length) h += '<div class="sheet__group"><div class="sheet__h"><span>بحثت مؤخراً</span><a href="#" data-recent-clear>مسح</a></div><div class="chips">' + rec.map(function (p) { return '<a class="chip" href="' + cfg.routes.search + '?q=' + encodeURIComponent(p) + '&type=product"><svg class="ic"><use href="#i-search"></use></svg>' + esc(p) + '</a>'; }).join('') + '</div></div>';
      if (cfg.popular.length) h += '<div class="sheet__group"><div class="sheet__h">' + S.popular + '</div><div class="chips">' + cfg.popular.map(function (p) { return '<a class="chip" href="' + cfg.routes.search + '?q=' + encodeURIComponent(p) + '&type=product"><svg class="ic"><use href="#i-search"></use></svg>' + esc(p) + '</a>'; }).join('') + '</div></div>';
      if (cfg.collections.length) h += '<div class="sheet__group"><div class="sheet__h">' + S.collections + '</div><div class="chips">' + cfg.collections.map(function (c) { return '<a class="chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div></div>';
      return h || '<div class="sheet__empty"><svg class="ic"><use href="#i-search"></use></svg><b>ابحث عن أي منتج</b></div>';
    },
    resultsHTML: function (q, r) {
      var s = this, h = '';
      var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      var hl = function (t) { return esc(t).replace(re, '<mark>$1</mark>'); };
      var prods = (r.products || []).map(normalize).filter(Boolean);
      if (prods.length) {
        h += '<div class="sheet__group"><div class="sheet__h"><span>' + S.products + '</span><a href="' + cfg.routes.search + '?q=' + encodeURIComponent(q) + '">' + S.viewAll + '</a></div>';
        h += prods.map(function (p) {
          var sale = p.compare && p.compare > p.price;
          return '<a class="sr" href="' + esc(p.url) + '"><img class="sr__img" src="' + esc(img(p.image, 160)) + '" alt="" loading="lazy" width="56" height="56">' +
            '<div class="sr__body"><div class="sr__title">' + hl(p.title) + '</div><div class="sr__meta"><span class="price' + (sale ? ' price--sale' : '') + '"><span class="price__now ltr">' + money(p.price) + '</span>' + (sale ? '<s class="price__was ltr">' + money(p.compare) + '</s>' : '') + '</span>' +
            '<i class="sr__dot' + (p.available ? '' : ' sr__dot--out') + '"></i><span>' + (p.available ? S.inStock : S.soldOut) + '</span></div></div><svg class="ic"><use href="#i-arrow"></use></svg></a>';
        }).join('') + '</div>';
      }
      if (r.collections && r.collections.length) h += '<div class="sheet__group"><div class="sheet__h">' + S.collections + '</div><div class="chips">' + r.collections.map(function (c) { return '<a class="chip" href="' + esc(c.url) + '">' + hl(c.title) + '</a>'; }).join('') + '</div></div>';
      if (r.queries && r.queries.length) h += '<div class="sheet__group"><div class="sheet__h">' + S.suggestions + '</div><div class="chips">' + r.queries.map(function (x) { return '<a class="chip" href="' + esc(x.url) + '"><svg class="ic"><use href="#i-search"></use></svg>' + esc(x.text) + '</a>'; }).join('') + '</div></div>';
      if (!h) h = '<div class="sheet__empty"><svg class="ic"><use href="#i-search"></use></svg><b>' + S.noResults + ' «' + esc(q) + '»</b><span>' + S.tryAgain + '</span></div>' + (cfg.collections.length ? '<div class="chips" style="justify-content:center">' + cfg.collections.slice(0, 6).map(function (c) { return '<a class="chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>' : '');
      return h;
    }
  };
  Search.closeBound = function () { Search.close(); };
  Search.init();

  /* dock: mark current page (the wishlist may live at /search?view=wishlist, so compare the view param too) */
  (function () {
    var path = location.pathname.replace(/\/$/, '') || '/';
    var view = new URLSearchParams(location.search).get('view') || '';
    $$('.dock__btn[href]').forEach(function (a) {
      var u; try { u = new URL(a.getAttribute('href'), location.origin); } catch (e) { return; }
      var hp = u.pathname.replace(/\/$/, '') || '/';
      if (hp === path && (u.searchParams.get('view') || '') === view) a.classList.add('is-on');
    });
  })();

  /* ------------------------------------------------------------------ filters drawer (collection) */
  /* resolved lazily: the collection section is re-rendered by ajax filtering, so the element changes */
  var Filters = {
    open: function () { var el = $('[data-filters]'); if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lock(true); scrimOn(Filters.closeBound); },
    close: function () { var el = $('[data-filters].is-open'); if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); lock(false); scrimOff(Filters.closeBound); }
  };
  Filters.closeBound = function () { Filters.close(); };
  on(document, 'click', function (e) {
    if (e.target.closest('[data-filters-open]')) { e.preventDefault(); Filters.open(); }
    if (e.target.closest('[data-filters-close]')) { Filters.close(); }
  });

  /* ------------------------------------------------------------------ per-root initialisers */
  function initReveal(root) {
    var els = $$('[data-reveal]:not(.in)', root); if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    els.forEach(function (e, i) { e.style.transitionDelay = Math.min(i % 8, 6) * 40 + 'ms'; io.observe(e); });
  }

  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (wrap) {
      if (wrap.__tabs) return; wrap.__tabs = true;
      var tabs = $$('[role="tab"]', wrap), panels = $$('[role="tabpanel"]', wrap);
      var go = function (i) {
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
        tabs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduced ? 'auto' : 'smooth' });
        initReveal(panels[i]);
      };
      tabs.forEach(function (t, i) { on(t, 'click', function () { go(i); }); });
    });
  }

  function initReels(root) {
    var vids = $$('.reel video', root); if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target, reel = v.closest('.reel');
        if (en.intersectionRatio > 0.6 && !reel.classList.contains('is-paused')) { var p = v.play(); if (p && p.catch) p.catch(function () { }); reel.classList.add('is-playing'); }
        else { v.pause(); }
      });
    }, { threshold: [0, 0.6, 1] });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); io.observe(v); });
    $$('.reel__play', root).forEach(function (b) {
      on(b, 'click', function () {
        var reel = b.closest('.reel'), v = $('video', reel);
        if (v.paused) { reel.classList.remove('is-paused'); v.play(); reel.classList.add('is-playing'); }
        else { reel.classList.add('is-paused'); v.pause(); }
      });
    });
  }

  /* product page */
  function initProduct(root) {
    $$('[data-product]', root).forEach(function (el) {
      if (el.__init) return; el.__init = true;
      var data = $('[data-product-json]', el); if (!data) return;
      var product = JSON.parse(data.textContent);
      var form = $('form[data-product-form]', el);
      var idInput = form && $('input[name="id"]', form);
      var priceNow = $('[data-price]', el), priceWas = $('[data-compare]', el), priceWrap = $('[data-price-wrap]', el);
      var stock = $('[data-stock]', el), btn = $('[data-add-btn]', el), btnText = btn && $('span', btn);
      var stickyPrice = $('[data-sticky-price]', el), stickyBtn = $('[data-sticky-add]', el);
      var badgeSale = $('[data-badge-sale]', el);
      var gal = $('[data-gallery]', el), dots = $$('[data-gallery-dots] i', el), thumbs = $$('[data-thumb]', el);
      var items = gal ? $$('.gal__it', gal) : [];

      function selected() {
        return $$('[data-option-index]', el).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
      }
      function findVariant(opts) {
        return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
      }
      function paintAvailability(opts) {
        /* grey out option values that would produce an unavailable variant given other selections */
        $$('[data-option-index]', el).forEach(function (g, gi) {
          $$('.pill', g).forEach(function (pill) {
            var val = $('input', pill).value;
            var test = opts.slice(); test[gi] = val;
            var v = findVariant(test);
            pill.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }
      function scrollToMedia(mediaId) {
        if (!gal || !mediaId) return;
        var i = items.findIndex(function (it) { return it.getAttribute('data-media-id') === String(mediaId); });
        if (i > -1) gal.scrollTo({ left: items[i].offsetLeft - gal.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      }
      function update(v, first) {
        if (!v) {
          if (btn) { btn.disabled = true; btnText && (btnText.textContent = S.unavailable); }
          if (stock) { stock.textContent = S.unavailable; stock.className = 'pdp__stock pdp__stock--out'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price);
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceWas) { priceWas.textContent = sale ? money(v.compare_at_price) : ''; priceWas.hidden = !sale; }
        if (priceWrap) priceWrap.classList.toggle('price--sale', !!sale);
        if (badgeSale) { badgeSale.hidden = !sale; if (sale) badgeSale.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (btn) { btn.disabled = !v.available; btnText && (btnText.textContent = v.available ? S.addToCart : S.soldOut); }
        if (stickyBtn) { stickyBtn.disabled = !v.available; $('span', stickyBtn) && ($('span', stickyBtn).textContent = v.available ? S.addToCart : S.soldOut); }
        if (stock) {
          var q = v.inventory_quantity, managed = v.inventory_management;
          if (!v.available) { stock.textContent = S.soldOut; stock.className = 'pdp__stock pdp__stock--out'; }
          else if (managed && q != null && q > 0 && q <= 5) { stock.textContent = S.lowStock.replace('{n}', q); stock.className = 'pdp__stock pdp__stock--low'; }
          else { stock.textContent = S.inStock; stock.className = 'pdp__stock'; }
        }
        var waLink = $('[data-wa-stock]', el); if (waLink) waLink.hidden = v.available;
        if (!first && v.featured_media) scrollToMedia(v.featured_media.id);
        if (!first && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      }
      on(el, 'change', function (e) {
        if (!e.target.closest('[data-option-index]')) return;
        var opts = selected(); paintAvailability(opts); update(findVariant(opts));
      });
      var cur = product.variants.filter(function (v) { return idInput && String(v.id) === String(idInput.value); })[0] || product.variants[0];
      if ($$('[data-option-index]', el).length) paintAvailability(selected());
      update(cur, true);

      /* gallery dots + thumbs */
      if (gal && items.length > 1) {
        var setActive = function () {
          var i = Math.round(gal.scrollLeft / gal.clientWidth); i = Math.abs(i);
          if (i >= items.length) i = items.length - 1;
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
          thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        };
        var raf = false; on(gal, 'scroll', function () { if (!raf) { raf = true; requestAnimationFrame(function () { setActive(); raf = false; }); } }, { passive: true });
        thumbs.forEach(function (t, k) { on(t, 'click', function () { gal.scrollTo({ left: items[k].offsetLeft - gal.offsetLeft, behavior: reduced ? 'auto' : 'smooth' }); }); });
        setActive();
      }

      /* quantity */
      on(el, 'click', function (e) {
        var b = e.target.closest('[data-pqty]'); if (!b) return;
        var input = $('input', b.parentNode); var n = Math.max(1, (parseInt(input.value, 10) || 1) + (b.getAttribute('data-pqty') === '+' ? 1 : -1)); input.value = n;
      });

      /* sticky buy bar */
      var sticky = $('[data-sticky-buy]', el), buy = $('[data-buy-anchor]', el);
      if (sticky && buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('is-on', show); document.body.classList.toggle('has-sticky-buy', show); }, { threshold: 0 }).observe(buy);
        on(stickyBtn, 'click', function () { if (form) form.requestSubmit ? form.requestSubmit() : $('[data-add-btn]', form).click(); });
      }

      /* recommendations */
      var rec = $('[data-recommendations]', el.parentNode) || $('[data-recommendations]');
      if (rec && !rec.__done) {
        rec.__done = true;
        fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'); var fresh = $('[data-recommendations]', doc);
          if (fresh && $('.card', fresh)) { rec.innerHTML = fresh.innerHTML; rec.hidden = false; init(rec); } else rec.remove();
        }).catch(function () { rec.remove(); });
      }
    });
  }

  /* collection ajax filtering + sorting */
  function initCollection(root) {
    $$('[data-collection]', root).forEach(function (el) {
      if (el.__init) return; el.__init = true;
      var id = el.getAttribute('data-section-id');
      var form = $('form[data-filter-form]', el), sort = $('[data-sort]', el), grid = $('[data-grid]', el);
      var load = function (url, push) {
        grid && grid.classList.add('is-loading');
        var u = new URL(url, location.origin); u.searchParams.set('section_id', id);
        fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'); var fresh = $('[data-collection]', doc);
          if (!fresh) { location.href = url; return; }
          el.innerHTML = fresh.innerHTML; el.__init = false; init(el);
          if (push !== false) history.pushState({ ns: url }, '', url);
          var top = el.getBoundingClientRect().top + window.scrollY - 70; if (window.scrollY > top) window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
        }).catch(function () { location.href = url; });
      };
      var build = function () {
        /* keep unrelated params (q, type…), drop the ones this form controls, then rebuild from the form + sort */
        var u = new URL(location.href);
        Array.prototype.slice.call(u.searchParams.keys()).forEach(function (k) { if (k.indexOf('filter.') === 0 || k === 'sort_by' || k === 'page' || k === 'section_id') u.searchParams.delete(k); });
        if (form) { var fd = new FormData(form); fd.forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); }); }
        if (sort && sort.value) u.searchParams.set('sort_by', sort.value);
        return u.pathname + (u.search || '');
      };
      on(sort, 'change', function () { load(build()); });
      if (form) {
        on(form, 'change', debounce(function () { load(build()); }, 250));
        on(form, 'submit', function (e) { e.preventDefault(); load(build()); Filters.close(); });
      }
      on(el, 'click', function (e) {
        var a = e.target.closest('a[data-ajax-link]'); if (!a) return; e.preventDefault(); load(a.getAttribute('href'));
      });
    });
    if (!window.__nsPop) { window.__nsPop = true; on(window, 'popstate', function () { if ($('[data-collection]')) location.reload(); }); }
  }

  /* wishlist page */
  function wishlistEmptyCheck() {
    var page = $('[data-wishlist-page]'); if (!page) return;
    var grid = $('[data-grid]', page), empty = $('[data-empty]', page);
    var n = $$('.card', grid).length; empty.hidden = n > 0; grid.hidden = n === 0;
    var clear = $('[data-wish-clear]', page); if (clear) clear.hidden = n === 0;
  }
  function initWishlistPage(root) {
    var page = $('[data-wishlist-page]', root); if (!page || page.__init) return; page.__init = true;
    var grid = $('[data-grid]', page), handles = Wish.get();
    on($('[data-wish-clear]', page), 'click', function () { Wish.set([]); grid.innerHTML = ''; wishlistEmptyCheck(); });
    if (!handles.length) { wishlistEmptyCheck(); return; }
    grid.innerHTML = handles.map(function () { return '<div class="skel" style="aspect-ratio:1/1.45"></div>'; }).join('');
    Promise.all(handles.map(function (h) { return cardData(h).catch(function () { return null; }); })).then(function (list) {
      var keep = [];
      grid.innerHTML = list.map(function (p, i) { if (!p) return ''; keep.push(handles[i]); return cardHTML(p); }).join('');
      if (keep.length !== handles.length) Wish.set(keep);
      wishlistEmptyCheck(); init(grid);
    });
  }

  /* ------------------------------------------------------------------ polish: image fade-in, to-top, zoom, recently viewed, wishlist add-all */
  function initImages(root) {
    $$('.card__img img', root).forEach(function (im) { if (im.complete && im.naturalWidth) im.classList.add('is-loaded'); });
  }
  on(document, 'load', function (e) { var t = e.target; if (t && t.tagName === 'IMG') t.classList.add('is-loaded'); }, true);
  on(document, 'error', function (e) { var t = e.target; if (t && t.tagName === 'IMG') t.classList.add('is-loaded'); }, true);

  var totop = $('[data-totop]');
  if (totop) {
    var tt = false;
    on(window, 'scroll', function () { if (!tt) { tt = true; requestAnimationFrame(function () { totop.classList.toggle('is-on', window.scrollY > 900); tt = false; }); } }, { passive: true });
    on(totop, 'click', function () { window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); });
  }

  var zoomEl;
  function zoomOpen(src) {
    if (!zoomEl) {
      zoomEl = document.createElement('div'); zoomEl.className = 'zoom'; zoomEl.innerHTML = '<img alt=""><button class="zoom__close" type="button" aria-label="إغلاق"><svg class="ic"><use href="#i-close"></use></svg></button>';
      document.body.appendChild(zoomEl);
      on(zoomEl, 'click', function () { zoomEl.classList.remove('is-on'); lock(false); });
    }
    $('img', zoomEl).src = src; zoomEl.classList.add('is-on'); lock(true);
  }
  on(document, 'click', function (e) {
    var im = e.target.closest('.gal__it img'); if (!im) return;
    var src = im.currentSrc || im.src; zoomOpen(img(src.replace(/([?&])width=\d+/, '$1width=1600'), 1600));
  });
  on(document, 'keydown', function (e) { if (e.key === 'Escape' && zoomEl && zoomEl.classList.contains('is-on')) { zoomEl.classList.remove('is-on'); lock(false); } });

  var Recent = {
    key: 'ns-recent',
    get: function () { try { return JSON.parse(localStorage.getItem(this.key) || '[]'); } catch (e) { return []; } },
    add: function (h) { if (!h) return; var a = this.get().filter(function (x) { return x !== h; }); a.unshift(h); try { localStorage.setItem(this.key, JSON.stringify(a.slice(0, 12))); } catch (e) { } }
  };
  function initRecent(root) {
    var box = $('[data-recent]', root); if (!box || box.__init) return; box.__init = true;
    var cur = $('[data-product]'); var handle = cur && cur.getAttribute('data-handle');
    var list = Recent.get().filter(function (h) { return h !== handle; }).slice(0, 8);
    if (handle) Recent.add(handle);
    if (!list.length) return;
    Promise.all(list.map(function (h) { return cardData(h).catch(function () { return null; }); })).then(function (ps) {
      ps = ps.filter(Boolean); if (!ps.length) return;
      $('[data-grid]', box).innerHTML = ps.map(function (p) { return cardHTML(p, { cls: 'card--rail' }); }).join('');
      box.hidden = false; init(box);
    });
  }

  on(document, 'click', function (e) {
    var b = e.target.closest('[data-wish-add-all]'); if (!b) return;
    var items = $$('[data-wishlist-page] form[data-ajax-add]').map(formItem);
    if (!items.length) { toast({ text: 'ما في منتجات جاهزة للإضافة', icon: 'alert' }); return; }
    Cart.add({ items: items }, b);
  });

  /* ------------------------------------------------------------------ interactive hero (floating gallery)
     pointer / finger / gyroscope / scroll parallax with depth per card, 3D tilt on the hovered card,
     a light that follows the cursor, and colour dots for the ambience. Everything is transform-only. */
  function initFloat(root) {
    $$('[data-float]', root).forEach(function (st) {
      if (st.__init) return; st.__init = true;
      var items = $$('.float__item', st), amb = $('.float__amb', st), cur = $('.float__cursor', st);
      var tx = 0, ty = 0, cx = 0, cy = 0, sc = 0, hover = null, hx = 0, hy = 0, running = false, touch = window.matchMedia('(hover: none)').matches;
      var clamp = function (v) { return Math.max(-1, Math.min(1, v)); };
      function apply() {
        items.forEach(function (it) {
          var z = parseFloat(it.style.getPropertyValue('--z')) || 1;
          var amp = touch ? 8 : 16;
          var t = 'translate3d(' + (cx * amp * z).toFixed(2) + 'px,' + (cy * amp * 0.75 * z - sc * 26 * z).toFixed(2) + 'px,0)';
          if (it === hover) t += ' rotateX(' + (-hy * 9).toFixed(2) + 'deg) rotateY(' + (hx * 9).toFixed(2) + 'deg) scale(1.04)';
          it.style.transform = t;
        });
        if (amb) amb.style.transform = 'translate3d(' + (cx * (touch ? -10 : -22)).toFixed(2) + 'px,' + (cy * (touch ? -8 : -16)).toFixed(2) + 'px,0)';
      }
      function loop() {
        cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
        apply();
        if (Math.abs(tx - cx) > 0.002 || Math.abs(ty - cy) > 0.002) requestAnimationFrame(loop); else { cx = tx; cy = ty; apply(); running = false; }
      }
      function kick() { if (!running) { running = true; requestAnimationFrame(loop); } }
      function point(x, y) {
        var r = st.getBoundingClientRect();
        tx = clamp((x - r.left) / r.width * 2 - 1); ty = clamp((y - r.top) / r.height * 2 - 1);
        if (cur && !touch) { cur.style.transform = 'translate3d(' + (x - r.left) + 'px,' + (y - r.top) + 'px,0) translate(-50%,-50%)'; }
        if (hover) { var hr = hover.getBoundingClientRect(); hx = clamp((x - hr.left) / hr.width * 2 - 1); hy = clamp((y - hr.top) / hr.height * 2 - 1); }
        kick();
      }
      if (reduced) return;
      if (!touch) {
        on(st, 'pointermove', function (e) { point(e.clientX, e.clientY); });
        on(st, 'pointerenter', function () { st.classList.add('is-hover'); });
        on(st, 'pointerleave', function () { st.classList.remove('is-hover'); hover = null; tx = 0; ty = 0; kick(); });
        items.forEach(function (it) { on(it, 'pointerenter', function () { hover = it; }); on(it, 'pointerleave', function () { if (hover === it) hover = null; kick(); }); });
      } else {
        on(st, 'touchmove', function (e) { var t = e.touches[0]; if (t) point(t.clientX, t.clientY); }, { passive: true });
        on(st, 'touchend', function () { tx = 0; ty = 0; kick(); }, { passive: true });
        /* gyroscope where it needs no permission (Android); iOS silently keeps touch + scroll parallax */
        if (window.DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission !== 'function') {
          var base = null;
          on(window, 'deviceorientation', function (e) {
            if (e.gamma == null || e.beta == null) return;
            if (base === null) base = e.beta;
            tx = clamp(e.gamma / 28); ty = clamp((e.beta - base) / 28); kick();
          });
        }
      }
      var st2 = false;
      on(window, 'scroll', function () { if (st2) return; st2 = true; requestAnimationFrame(function () { st2 = false; var r = st.getBoundingClientRect(); sc = Math.max(0, Math.min(1, -r.top / (r.height || 1))); apply(); }); }, { passive: true });
    });
  }

  /* keep the dock, search sheet and floating buttons above the on-screen keyboard (phones) */
  if (window.visualViewport) {
    var vv = window.visualViewport, vvT = false;
    var vvUpdate = function () {
      var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      document.documentElement.style.setProperty('--kb', kb + 'px');
      document.documentElement.style.setProperty('--vvh', Math.round(vv.height) + 'px');
    };
    var vvSchedule = function () { if (!vvT) { vvT = true; requestAnimationFrame(function () { vvT = false; vvUpdate(); }); } };
    vv.addEventListener('resize', vvSchedule); vv.addEventListener('scroll', vvSchedule); vvUpdate();
  }

  /* ------------------------------------------------------------------ keycaps board (sections/ns-keycaps.liquid)
     The section is a keyboard and every key is a keycap set. Press or tap a key, or type its letter on a real keyboard,
     and the board's screen types that set out. Space = random, arrows = step, ⌫ = back, Enter = the set's action
     (add to cart / choose options / ask on WhatsApp), Fn = typing on/off. The "thock" is synthesised (no audio files)
     and only plays once the visitor turns sound on; on touch every feedback waits for a real tap, not a scroll. */
  var KC = { boards: [], on: null, type: true, ac: null };
  try {
    var kcSaved = localStorage.getItem('ns-kc-sound'); if (kcSaved) KC.on = kcSaved === '1';
    KC.type = localStorage.getItem('ns-kc-type') !== '0';
  } catch (e) { }
  function kcThock() {
    try {
      var A = KC.ac || (KC.ac = new (window.AudioContext || window.webkitAudioContext)());
      if (A.state === 'suspended') { var pr = A.resume(); if (pr && pr.catch) pr.catch(function () { }); }
      var t = A.currentTime, len = Math.floor(A.sampleRate * 0.045), buf = A.createBuffer(1, len, A.sampleRate), d = buf.getChannelData(0);
      for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 5);
      var src = A.createBufferSource(), lp = A.createBiquadFilter(), g = A.createGain();
      src.buffer = buf; lp.type = 'lowpass'; lp.frequency.value = 2300; g.gain.value = 0.45;
      src.connect(lp); lp.connect(g); g.connect(A.destination); src.start(t);
      var o = A.createOscillator(), og = A.createGain();
      o.frequency.setValueAtTime(150, t); o.frequency.exponentialRampToValueAtTime(55, t + 0.07);
      og.gain.setValueAtTime(0.28, t); og.gain.exponentialRampToValueAtTime(0.001, t + 0.09);
      o.connect(og); og.connect(A.destination); o.start(t); o.stop(t + 0.1);
    } catch (e) { }
  }
  function initKeycaps(root) {
    $$('[data-kc]', root).forEach(function (el) {
      if (el.__init) return; el.__init = true;
      var board = $('[data-kc-board]', el), keys = $$('[data-kc-key]', el), panels = $$('[data-kc-panel]', el);
      var live = $('[data-kc-live]', el), pop = $('[data-kc-pop]', el), popImg = pop && $('img', pop);
      var enterLabel = $('[data-kc-enter-label]', el), enterKey = $('[data-kc-act="add"]', el);
      if (!board || !keys.length) return;
      if (KC.on === null) KC.on = el.getAttribute('data-kc-sound') === 'true';
      var b = { el: el, cur: 0, hist: [], tt: 0, spin: false, lp: 0, lk: null };

      function paint() {
        var s = $('[data-kc-act="sound"]', el), f = $('[data-kc-act="type"]', el);
        if (s) { s.setAttribute('aria-pressed', KC.on ? 'true' : 'false'); var u = $('use', s); if (u) u.setAttribute('href', KC.on ? '#i-sound' : '#i-mute'); }
        if (f) f.setAttribute('aria-pressed', KC.type ? 'true' : 'false');
      }
      /* the physical feel of a key: travel down, thock, a tick of haptics on touch */
      function feel(k, hold) {
        k.classList.add('is-press'); clearTimeout(k.__pt);
        if (!hold) k.__pt = setTimeout(function () { k.classList.remove('is-press'); }, 130);
        if (KC.on) kcThock();
        if (k.__touch && navigator.vibrate) { try { navigator.vibrate(8); } catch (x) { } }
      }
      /* RGB ripple from the pressed key across the whole board */
      function wave(from) {
        if (reduced || !from) return;
        var all = $$('.kc__key', el), br = board.getBoundingClientRect(), r0 = from.getBoundingClientRect();
        var cx = r0.left + r0.width / 2, cy = r0.top + r0.height / 2, u = r0.height || 60;
        all.forEach(function (k) { k.classList.remove('is-wave'); });
        void board.offsetWidth;
        all.forEach(function (k) {
          var r = k.getBoundingClientRect(); if (!r.width) return;
          var dx = (r.left + r.width / 2 - cx) / u, dy = (r.top + r.height / 2 - cy) / u;
          k.style.setProperty('--d', Math.round(Math.sqrt(dx * dx + dy * dy) * 55) + 'ms');
          k.style.setProperty('--h', Math.round(190 + (r.left + r.width / 2 - br.left) / br.width * 140));
          k.classList.add('is-wave');
        });
      }
      function type(panel) {
        var h = panel && $('[data-kc-type]', panel); if (!h) return;
        var chars = Array.from(h.getAttribute('data-kc-type') || ''), n = 0;
        clearInterval(b.tt);
        if (reduced) { h.textContent = chars.join(''); return; }
        h.textContent = ''; h.classList.add('is-typing');
        b.tt = setInterval(function () {
          n += 1; h.textContent = chars.slice(0, n).join('');
          if (n >= chars.length) { clearInterval(b.tt); h.classList.remove('is-typing'); }
        }, Math.max(18, Math.min(48, 720 / (chars.length || 1))));
      }
      function current() { return panels.filter(function (p) { return !p.hidden; })[0]; }
      function show(i, o) {
        o = o || {};
        if (i < 0 || i >= keys.length) return;
        if (!o.back && !o.init && i !== b.cur) { b.hist.push(b.cur); if (b.hist.length > 40) b.hist.shift(); }
        b.cur = i;
        keys.forEach(function (k, j) {
          if (j === i) k.setAttribute('aria-current', 'true'); else k.removeAttribute('aria-current');
          k.tabIndex = j === i ? 0 : -1;
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-kc-panel') !== String(i); });
        var act = $('[data-kc-enter]', current());
        if (enterLabel) enterLabel.textContent = act ? act.getAttribute('data-kc-enter') : S.soldOut;
        if (enterKey) enterKey.disabled = !act;
        if (!o.init) { type(current()); board.classList.remove('is-fresh'); }
        if (o.focus) keys[i].focus({ preventScroll: true });
        else if (!o.init && live) live.textContent = keys[i].getAttribute('aria-label');   /* focus already announces it otherwise */
      }
      function hit(k, o) { wave(k); show(parseInt(k.getAttribute('data-kc-key'), 10), o); }
      function step(d, f) { show((b.cur + d + keys.length) % keys.length, { focus: f }); wave(keys[b.cur]); }
      /* Space: a slot-machine flick across the keys that lands on an in-stock set */
      function shuffle(f) {
        if (b.spin) return;
        var pool = keys.map(function (k, j) { return j; }).filter(function (j) { return j !== b.cur && !keys[j].classList.contains('is-out'); });
        if (!pool.length) pool = keys.map(function (k, j) { return j; }).filter(function (j) { return j !== b.cur; });
        if (!pool.length) return;
        var target = pool[Math.floor(Math.random() * pool.length)];
        if (reduced) { hit(keys[target], { focus: f }); return; }
        b.spin = true;
        var s = 0, steps = 10, last = null, from = b.cur;
        (function tick() {
          if (last) last.classList.remove('is-lit');
          if (b.cur !== from) { b.spin = false; return; }   /* the visitor picked something mid-spin: theirs wins */
          var j = s < steps - 1 ? Math.floor(Math.random() * keys.length) : target;
          last = keys[j]; last.classList.add('is-lit'); feel(last);
          s += 1;
          if (s < steps) setTimeout(tick, 45 + s * s * 3);
          else setTimeout(function () {
            last.classList.remove('is-lit'); b.spin = false;
            if (b.cur === from) hit(keys[target], { focus: f && onKey() });   /* only pull focus if it's still on a key */
          }, 140);
        })();
      }
      /* Enter: whatever the current set allows (its data-kc-enter element in the screen) */
      function enter() {
        var t = $('[data-kc-enter]', current() || el);
        if (!t) { toast({ text: S.soldOut, icon: 'alert' }); return; }
        if (t.tagName === 'FORM') { var btn = $('button[type="submit"]', t); if (btn) btn.click(); }
        else if (t.target === '_blank') window.open(t.href, '_blank', 'noopener');
        else location.href = t.href;
      }
      function onKey() { var a = document.activeElement; return !!(a && a.hasAttribute('data-kc-key') && el.contains(a)); }
      function act(name, f) {
        if (name === 'next') step(1, f);
        else if (name === 'prev') step(-1, f);
        else if (name === 'back') { if (b.hist.length) { var i = b.hist.pop(); show(i, { back: true, focus: f }); wave(keys[i]); } }
        else if (name === 'random') shuffle(f);
        else if (name === 'add') enter();
        else if (name === 'sound' || name === 'type') {
          if (name === 'sound') KC.on = !KC.on; else KC.type = !KC.type;
          try { localStorage.setItem('ns-kc-' + name, (name === 'sound' ? KC.on : KC.type) ? '1' : '0'); } catch (x) { }
          KC.boards.forEach(function (x) { x.paint(); });
          if (name === 'sound' && KC.on) kcThock();
        }
      }
      function showPop(k) {
        var im = $('.kc__top img', k); if (!im || !pop || !popImg) return;
        var r = k.getBoundingClientRect(), br = board.getBoundingClientRect();
        popImg.src = im.currentSrc || im.src;
        pop.style.left = (r.left + r.width / 2 - br.left) + 'px'; pop.style.top = (r.top - br.top - 6) + 'px';
        pop.classList.add('is-on');
      }
      function endPress(k, keepFelt) {
        clearTimeout(b.lp); b.lk = null;
        if (pop) pop.classList.remove('is-on');
        if (k) { if (!keepFelt) k.__felt = false; clearTimeout(k.__pt); k.__pt = setTimeout(function () { k.classList.remove('is-press'); }, 60); }
      }

      /* one pointer at a time (a second finger is ignored) */
      on(el, 'pointerdown', function (e) {
        if (!e.isPrimary) return;
        var k = e.target.closest('.kc__key--p, [data-kc-act]'); if (!k || !el.contains(k) || k.disabled) return;
        if (b.lk && b.lk !== k) endPress(b.lk);
        if (e.pointerType === 'mouse') { k.__touch = false; if (e.button !== 0) return; feel(k, true); k.__felt = true; b.lk = k; return; }
        /* touch / pen: the finger may be starting a scroll, so nothing yet. Holding it shows the enlarged key;
           a plain tap gets its thock and haptic from the click (a real user activation, so audio + vibrate are allowed) */
        k.__touch = true; k.__felt = false; b.lk = k; b.px = e.clientX; b.py = e.clientY;
        clearTimeout(b.lp);
        b.lp = setTimeout(function () { feel(k, true); k.__felt = true; if (k.hasAttribute('data-kc-key')) showPop(k); }, 170);
      });
      on(el, 'pointermove', function (e) {
        if (e.isPrimary && b.lk && b.lk.__touch && (Math.abs(e.clientX - b.px) > 8 || Math.abs(e.clientY - b.py) > 8)) endPress(b.lk, true);
      });
      on(el, 'pointerup', function (e) { if (e.isPrimary) endPress(b.lk, true); });
      on(el, 'pointercancel', function (e) { if (e.isPrimary) endPress(b.lk); });
      on(el, 'pointerleave', function (e) { if (e.isPrimary) endPress(b.lk, true); });
      on(el, 'contextmenu', function (e) { var k = e.target.closest('.kc__key--p'); if (k && k === b.lk && k.__touch) e.preventDefault(); });   /* long press: our pop, not the link menu */
      on(el, 'dragstart', function (e) { if (e.target.closest && e.target.closest('.kc__key')) e.preventDefault(); });
      on(el, 'click', function (e) {
        var k = e.target.closest('[data-kc-key]');
        if (k && el.contains(k)) {
          if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button) { k.__felt = false; return; }   /* let "open in new tab" through */
          e.preventDefault();
          if (!k.__felt || e.detail === 0) feel(k);   /* detail 0: a keyboard-made click, no pointer press before it */
          k.__felt = false; k.__touch = false;
          hit(k, { focus: true });
          return;
        }
        var a = e.target.closest('[data-kc-act]');
        if (a && el.contains(a)) {
          if (!a.__felt || e.detail === 0) feel(a); a.__felt = false;
          var nm = a.getAttribute('data-kc-act');
          act(nm, nm === 'back' || nm === 'random' ? onKey() : false);
          return;
        }
        var dot = e.target.closest('[data-kc-dot]'), shot = !dot && e.target.closest('[data-kc-shot]');
        if (dot || shot) {
          var p = (dot || shot).closest('[data-kc-panel]'), imgs = $$('.kc__img', p), dots = $$('[data-kc-dot]', p);
          var now = imgs.findIndex(function (x) { return x.classList.contains('is-on'); });
          var n = dot ? parseInt(dot.getAttribute('data-kc-dot'), 10) : (now + 1) % imgs.length;
          imgs.forEach(function (x, j) { x.classList.toggle('is-on', j === n); });
          dots.forEach(function (x, j) { x.setAttribute('aria-pressed', j === n ? 'true' : 'false'); });
        }
      });

      b.hit = function (k) { feel(k, true); hit(k, { focus: true }); };
      b.act = act; b.step = step; b.paint = paint; b.board = board; b.enterKey = enterKey; b.feel = feel;
      KC.boards.push(b);
      paint();
      show(0, { init: true });
      board.classList.add('is-fresh');   /* a pulsing ring on the first key until the first press */

      /* first time the board scrolls into view: a light sweep from Q and the first set typed out */
      var intro = function () { wave(keys[0]); type(current()); };
      if ('IntersectionObserver' in window && !reduced) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); intro(); } }, { threshold: 0.35 });
        io.observe(board); b.io = io;
      }
    });
  }
  /* a board counts as on screen when at least half of it (or half the viewport) is visible */
  function kcSeen(x) {
    var r = x.board.getBoundingClientRect(), vh = window.innerHeight, s = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    return s >= Math.min(r.height, vh) * 0.5 ? s : 0;
  }
  function kcActive() {
    KC.boards = KC.boards.filter(function (x) { return x.el.isConnected; });
    var inside = KC.boards.filter(function (x) { return x.el.contains(document.activeElement); })[0];
    if (inside && kcSeen(inside)) return { b: inside, inside: true };
    var best = null, bestSeen = 0;
    KC.boards.forEach(function (x) { var s = kcSeen(x); if (s > bestSeen) { best = x; bestSeen = s; } });
    return best ? { b: best, inside: false } : null;
  }
  /* real keyboard → board. Letters work while a board is mostly on screen (Fn on the board switches that off);
     Space / arrows / Backspace / Enter only while focus is on one of its product keys, so the page behaves as usual. */
  on(document, 'keydown', function (e) {
    if (!KC.boards.length || e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey || document.body.classList.contains('is-locked')) return;
    var t = (e.composedPath && e.composedPath()[0]) || e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    var a = kcActive(); if (!a) return;
    if (/^Key[A-Z]$/.test(e.code)) {
      var fn = $('[data-kc-act="type"]', a.b.el);
      if (!KC.type || !fn || !fn.offsetParent) return;   /* only where its Fn off-switch is on screen (the phone layout hides it) */
      var k = $('[data-kc-code="' + e.code + '"]', a.b.el);
      if (k) { e.preventDefault(); if (!e.repeat) a.b.hit(k); }
      return;
    }
    var fk = document.activeElement;
    if (!a.inside || !fk.hasAttribute('data-kc-key')) return;
    if (e.key === 'Enter' && fk.getAttribute('aria-current') === 'true') {   /* first Enter picks a key, Enter on the picked one acts */
      e.preventDefault(); if (e.repeat) return;
      if (a.b.enterKey) a.b.feel(a.b.enterKey);
      a.b.act('add');
    }
    else if (e.code === 'Space') { e.preventDefault(); if (!e.repeat) a.b.act('random', true); }
    else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); a.b.step(1, true); }
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); a.b.step(-1, true); }
    else if (e.key === 'Backspace') { e.preventDefault(); a.b.act('back', true); }
  });
  on(document, 'keyup', function (e) {
    if (!/^Key[A-Z]$/.test(e.code)) return;
    KC.boards.forEach(function (x) { var k = $('[data-kc-code="' + e.code + '"].is-press', x.el); if (k) k.classList.remove('is-press'); });
  });
  on(document, 'shopify:section:unload', function (e) {
    KC.boards = KC.boards.filter(function (x) { if (e.target.contains(x.el)) { if (x.io) x.io.disconnect(); return false; } return true; });
  });

  /* ------------------------------------------------------------------ garage (sections/ns-garage.liquid)
     A night garage for the die-cast cars. The door peeks open; START fires the engine; the H-pattern shifter picks
     the car (each gear is a car and the knob travels the gate through neutral); the gas pedal revs to the redline and
     fires the car's action (quick add / options / WhatsApp). Swipe the stage to change car. The engine is
     synthesised (no audio files) and only ever sounds from a press, never on its own. */
  var GR = { boards: [], on: null, ac: null };
  try { var grSaved = localStorage.getItem('ns-gr-sound'); if (grSaved) GR.on = grSaved === '1'; } catch (e) { }
  function grCtx() {
    var A = GR.ac || (GR.ac = new (window.AudioContext || window.webkitAudioContext)());
    if (A.state === 'suspended') { var pr = A.resume(); if (pr && pr.catch) pr.catch(function () { }); }
    return A;
  }
  /* a V8-ish voice: two detuned saws + a square sub through a soft clipper and a low-pass that opens with rpm.
     plan: [[seconds, rpm], ...] from `delay`; the voice fades out at `life` */
  function grEngine(plan, life, vol, delay) {
    if (!GR.on) return;
    try {
      var A = grCtx(), t0 = A.currentTime + 0.02 + (delay || 0), peak = vol || 0.22;
      var out = A.createGain(), lp = A.createBiquadFilter(), sh = A.createWaveShaper(), mix = A.createGain(), sg = A.createGain();
      var curve = new Float32Array(256);
      for (var i = 0; i < 256; i++) curve[i] = Math.tanh((i / 128 - 1) * 2.6);
      sh.curve = curve; lp.type = 'lowpass'; lp.Q.value = 1.3; mix.gain.value = 0.45; sg.gain.value = 0.5;
      var o1 = A.createOscillator(), o2 = A.createOscillator(), sub = A.createOscillator();
      o1.type = o2.type = 'sawtooth'; sub.type = 'square'; o2.detune.value = 18;
      o1.connect(mix); o2.connect(mix); sub.connect(sg); sg.connect(mix); mix.connect(sh); sh.connect(lp); lp.connect(out); out.connect(A.destination);
      plan.forEach(function (st, k) {
        var t = t0 + st[0], hz = Math.max(8, st[1] / 60 * 4), cut = 260 + st[1] * 0.28;   /* V8: 4 firings a turn */
        if (!k) { o1.frequency.setValueAtTime(hz, t); o2.frequency.setValueAtTime(hz, t); sub.frequency.setValueAtTime(hz / 2, t); lp.frequency.setValueAtTime(cut, t); return; }
        o1.frequency.exponentialRampToValueAtTime(hz, t); o2.frequency.exponentialRampToValueAtTime(hz, t);
        sub.frequency.exponentialRampToValueAtTime(hz / 2, t); lp.frequency.linearRampToValueAtTime(cut, t);
      });
      out.gain.setValueAtTime(0.0001, t0); out.gain.exponentialRampToValueAtTime(peak, t0 + 0.06);
      out.gain.setValueAtTime(peak, t0 + Math.max(0.1, life - 0.45)); out.gain.exponentialRampToValueAtTime(0.0001, t0 + life);
      [o1, o2, sub].forEach(function (o) { o.start(t0); o.stop(t0 + life + 0.05); });
    } catch (e) { }
  }
  /* noise through a filter: the starter motor (whirring, amplitude-modulated) or the clunk of a gear going in */
  function grNoise(dur, type, freq, vol, whirr) {
    if (!GR.on) return;
    try {
      var A = grCtx(), t0 = A.currentTime + 0.02, len = Math.floor(A.sampleRate * dur), buf = A.createBuffer(1, len, A.sampleRate), d = buf.getChannelData(0);
      for (var i = 0; i < len; i++) {
        var env = whirr ? 0.55 + 0.45 * Math.sin(i / A.sampleRate * 13 * Math.PI * 2) : Math.pow(1 - i / len, 4);
        d[i] = (Math.random() * 2 - 1) * env;
      }
      var src = A.createBufferSource(), f = A.createBiquadFilter(), g = A.createGain();
      src.buffer = buf; f.type = type; f.frequency.value = freq; f.Q.value = 0.9; g.gain.value = vol;
      src.connect(f); f.connect(g); g.connect(A.destination); src.start(t0);
    } catch (e) { }
  }
  function initGarage(root) {
    $$('[data-gr]', root).forEach(function (el) {
      if (el.__init) return; el.__init = true;
      var rig = $('[data-gr-rig]', el), stage = $('[data-gr-stage]', el), door = $('[data-gr-door]', el);
      var cars = $$('[data-gr-car]', el), infos = $$('[data-gr-info]', el), radios = $$('input[data-gr-gear]', el);
      var gauge = $('[data-gr-gauge]', el), knob = $('[data-gr-knob]', el), pedal = $('[data-gr-pedal]', el), start = $('[data-gr-start]', el);
      var readout = $('[data-gr-readout]', el), was = $('[data-gr-was]', el), gearNo = $('[data-gr-gearno]', el);
      var pedalLabel = $('[data-gr-pedal-label]', el), pedalPrice = $('[data-gr-pedal-price]', el), live = $('[data-gr-live]', el), sound = $('[data-gr-sound]', el);
      if (!rig || !stage || !cars.length || cars.length !== infos.length) return;
      if (GR.on === null) GR.on = el.getAttribute('data-gr-sound') !== 'false';
      var n = cars.length, b = { el: el, cur: 0, running: false, open: !door, busy: false, kc: 0, kr: 0 };

      function paint() {
        if (!sound) return;
        sound.setAttribute('aria-pressed', GR.on ? 'true' : 'false');
        var u = $('use', sound); if (u) u.setAttribute('href', GR.on ? '#i-sound' : '#i-mute');
      }
      function replay(node, cls) { node.classList.remove(cls); void node.offsetWidth; node.classList.add(cls); }
      /* the needle: --rpm 0..8000 with its own transition time; seq() runs [[wait ms, rpm, transition ms], ...] */
      function rpm(v, ms) { if (!gauge) return; gauge.style.setProperty('--rpm-t', (reduced ? 0 : ms || 300) + 'ms'); gauge.style.setProperty('--rpm', v); }
      function seq(steps) {
        clearTimeout(b.rt); var k = 0;
        (function nx() { if (k >= steps.length) return; var s = steps[k++]; b.rt = setTimeout(function () { rpm(s[1], s[2]); nx(); }, s[0]); })();
      }
      function idle() { return b.running ? 850 : 0; }
      /* once the garage is in play, fetch every car's first photo so a gear change never shows an empty bay */
      function warm() {
        if (b.warm) return; b.warm = true;
        cars.forEach(function (c) { var im = $('.gr__img', c); if (im) im.loading = 'eager'; });
      }
      function openDoor(instant) {
        if (b.open) return; b.open = true;
        if (instant || reduced) rig.classList.add('is-instant');
        rig.classList.add('is-open');
        try { sessionStorage.setItem('ns-gr-open', '1'); } catch (x) { }
      }
      /* the knob goes back to neutral, across, then into the gear, like a real H-pattern */
      function knobTo(i) {
        if (!knob) return;
        var c = Math.floor(i / 2), r = i % 2;
        var set = function (cc, rr) { knob.style.setProperty('--kc', cc); knob.style.setProperty('--kr', rr); b.kc = cc; b.kr = rr; };
        clearTimeout(b.k1); clearTimeout(b.k2);
        if (reduced) { set(c, r); return; }
        set(b.kc, 0.5);
        b.k1 = setTimeout(function () { set(c, 0.5); b.k2 = setTimeout(function () { set(c, r); }, 115); }, 115);
      }
      function select(i, o) {
        o = o || {};
        if (i < 0 || i >= n || (i === b.cur && !o.init)) return;
        var prev = b.cur, dir = o.dir || (i > prev ? 1 : -1), inf = infos[i], go = $('[data-gr-go]', inf);
        b.cur = i;
        if (!o.init) { openDoor(); warm(); }
        /* stage: the old car drives out, the new one drives in */
        clearTimeout(b.dt);
        cars.forEach(function (c, j) { c.classList.remove('is-in', 'is-out'); if (j !== i && (j !== prev || o.init || reduced)) c.hidden = true; });
        cars[i].hidden = false;
        if (!o.init && !reduced && prev !== i) {
          stage.style.setProperty('--dir', dir);
          cars[prev].classList.add('is-out'); cars[i].classList.add('is-in'); replay(stage, 'is-drive');
          b.dt = setTimeout(function () { cars[prev].hidden = prev !== b.cur; cars[prev].classList.remove('is-out'); cars[i].classList.remove('is-in'); stage.classList.remove('is-drive'); }, 650);
        }
        infos.forEach(function (x, j) { x.hidden = j !== i; });
        radios.forEach(function (r, j) { r.checked = j === i; });
        rig.style.setProperty('--gr-c', inf.getAttribute('data-gr-color'));
        if (readout) readout.textContent = inf.getAttribute('data-gr-price');
        if (was) { var w = inf.getAttribute('data-gr-was'); was.textContent = w || ''; was.hidden = !w; }
        if (gearNo) gearNo.textContent = inf.getAttribute('data-gr-gno');
        if (pedal) {
          var label = go ? go.getAttribute('data-gr-label') : 'نفدت', buy = !!(go && go.tagName === 'FORM'), price = inf.getAttribute('data-gr-price');
          if (go && go.tagName === 'FORM') pedal.setAttribute('form', go.getAttribute('id')); else pedal.removeAttribute('form');   /* not go.id: the form's <input name="id"> shadows it */
          if (pedalLabel) pedalLabel.textContent = label;
          if (pedalPrice) { pedalPrice.hidden = !buy; $('bdi', pedalPrice).textContent = buy ? price : ''; }   /* the price rides on the buy pedal */
          pedal.setAttribute('aria-label', 'دوس بانزين، ' + label + (buy ? ' ' + price : '') + ': ' + inf.getAttribute('data-gr-name'));
          pedal.disabled = !go;
        }
        knobTo(i);
        if (o.init) return;
        seq([[0, 2800, 170], [230, idle(), 750]]);
        grNoise(0.07, 'lowpass', 900, 0.5); grEngine([[0, 950], [0.16, 2800], [0.7, 950]], 1.05, 0.14);
        if (live) live.textContent = inf.getAttribute('data-gr-name') + '، ' + inf.getAttribute('data-gr-price');
      }
      function toggleEngine() {
        openDoor(); warm(); start.classList.remove('is-fresh');
        if (b.running) {
          b.running = false; rig.classList.remove('is-running'); start.setAttribute('aria-pressed', 'false');
          seq([[0, 0, 900]]); grEngine([[0, 850], [0.5, 380]], 0.6, 0.16);
          return;
        }
        b.running = true; rig.classList.add('is-running'); start.setAttribute('aria-pressed', 'true');
        if (!reduced) { replay(stage, 'is-shake'); replay(stage, 'is-flare'); }
        seq([[0, 8000, 520], [560, 0, 480], [540, 2400, 220], [240, 850, 750]]);   /* cluster self-test, then it catches (waits are relative) */
        grNoise(0.6, 'bandpass', 220, 0.32, true);
        grEngine([[0, 380], [0.28, 2400], [0.95, 900], [1.6, 850]], 2.9, 0.24, 0.52);
      }
      function gas() {
        var inf = infos[b.cur], go = $('[data-gr-go]', inf);
        if (!go) { toast({ text: 'نفدت', icon: 'alert' }); return; }
        if (b.busy) return;
        openDoor(); warm();
        pedal.classList.add('is-down');
        seq([[0, 7300, 420], [540, idle(), 850]]);
        grEngine([[0, 950], [0.42, 6700], [0.56, 6500], [1.35, 950]], 1.65, 0.26);
        if (!reduced) replay(stage, 'is-shake');
        if (go.tagName !== 'FORM') {   /* links go now, inside the click, so pop-up blockers let WhatsApp through */
          setTimeout(function () { pedal.classList.remove('is-down'); }, 300);
          if (go.target === '_blank') window.open(go.href, '_blank', 'noopener'); else location.href = go.href;
          return;
        }
        b.busy = true;
        setTimeout(function () {
          if (go.requestSubmit) go.requestSubmit(); else go.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          /* the pedal stays down until the cart has answered (the ajax handler runs inside requestSubmit, so Cart.busy is already set) */
          (function wait() { if (Cart.busy) { setTimeout(wait, 150); return; } pedal.classList.remove('is-down'); b.busy = false; })();
        }, reduced ? 0 : 460);
      }
      function photo(nx) {
        var fig = cars[b.cur], imgs = $$('.gr__img', fig), dots = $$('[data-gr-dot]', fig);
        if (imgs.length < 2) return;
        var now = imgs.findIndex(function (x) { return x.classList.contains('is-on'); });
        var k = nx == null ? (now + 1) % imgs.length : nx;
        imgs.forEach(function (x, j) { x.classList.toggle('is-on', j === k); });
        dots.forEach(function (x, j) { x.setAttribute('aria-pressed', j === k ? 'true' : 'false'); });
      }

      on(el, 'change', function (e) { var r = e.target.closest('[data-gr-gear]'); if (r && r.checked) select(parseInt(r.value, 10)); });
      on(start, 'click', toggleEngine);
      on(pedal, 'click', function (e) { e.preventDefault(); gas(); });
      on(sound, 'click', function () {
        GR.on = !GR.on;
        try { localStorage.setItem('ns-gr-sound', GR.on ? '1' : '0'); } catch (x) { }
        GR.boards.forEach(function (x) { x.paint(); });
        if (GR.on) grEngine([[0, 950], [0.2, 2600], [0.6, 950]], 0.9, 0.16);
      });
      /* stage: swipe = change car (in RTL, dragging right brings the next one), tap = open the door / next photo */
      var sw = null;
      on(stage, 'pointerdown', function (e) { if (e.isPrimary) { sw = { x: e.clientX, y: e.clientY }; b.swiped = false; } });
      on(stage, 'pointercancel', function () { sw = null; });
      on(stage, 'pointerup', function (e) {
        if (!sw || !e.isPrimary) return;
        var dx = e.clientX - sw.x, dy = e.clientY - sw.y; sw = null;
        if (n > 1 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) { b.swiped = true; var d = dx > 0 ? 1 : -1; select((b.cur + d + n) % n, { dir: -d }); }   /* the cars move with the finger */
      });
      on(stage, 'click', function (e) {
        if (b.swiped) { b.swiped = false; return; }
        if (!b.open) { openDoor(); return; }
        var dot = e.target.closest('[data-gr-dot]');
        photo(dot ? parseInt(dot.getAttribute('data-gr-dot'), 10) : null);
      });
      on(stage, 'dragstart', function (e) { e.preventDefault(); });

      b.paint = paint; b.select = function (i) { openDoor(true); select(i); }; b.cars = cars;
      GR.boards.push(b);
      paint();
      select(0, { init: true });
      /* the door rolls up on its own once the garage has been on screen for a moment (and stays up for the visit) */
      var seen = false;
      try { seen = sessionStorage.getItem('ns-gr-open') === '1'; } catch (x) { }
      if (door && (seen || reduced)) openDoor(true);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          clearTimeout(b.ot);
          if (!en[0].isIntersecting) return;
          warm();
          if (b.open) io.disconnect(); else b.ot = setTimeout(function () { openDoor(); io.disconnect(); }, 2200);
        }, { threshold: 0.5 });
        io.observe(stage); b.io = io;
      } else { warm(); openDoor(true); }
    });
  }
  /* theme editor: selecting a car block shows that car */
  on(document, 'shopify:block:select', function (e) {
    GR.boards = GR.boards.filter(function (x) { return x.el.isConnected; });
    GR.boards.forEach(function (x) {
      if (!x.el.contains(e.target)) return;
      var i = x.cars.findIndex(function (c) { return c.getAttribute('data-gr-block') === (e.detail && e.detail.blockId); });
      if (i > -1) x.select(i);
    });
  });
  on(document, 'shopify:section:unload', function (e) {
    GR.boards = GR.boards.filter(function (x) { if (e.target.contains(x.el)) { if (x.io) x.io.disconnect(); return false; } return true; });
  });

  function init(root) {
    root = root || document;
    Wish.paint();
    initImages(root); initReveal(root); initTabs(root); initReels(root); initProduct(root); initCollection(root); initWishlistPage(root); initRecent(root); initFloat(root); initKeycaps(root); initGarage(root);
  }

  on(document, 'shopify:section:load', function (e) { init(e.target); });
  on(document, 'shopify:section:select', function (e) { init(e.target); });

  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', function () { init(); }); else init();

  window.NS = { money: money, cardHTML: cardHTML, normalize: normalize, cart: Cart, wish: Wish, toast: toast, search: Search, init: init, setTheme: setTheme, img: img };
})();
